import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { useFocusTrap } from '../../hooks.js';
import { ink } from '../../primitives.js';

const h = React.createElement;

/**
 * The side panel. Esc closes; full width under 640px.
 *
 * @param {object} p
 * @param {boolean} p.open
 * @param {() => void} p.onClose
 * @param {React.ReactNode} p.title
 * @param {React.ReactNode} [p.sub]
 * @param {React.ReactNode} [p.eyebrow]
 * @param {React.ReactNode} [p.children]
 * @param {React.ReactNode} [p.footer]
 * @param {number} [p.width]
 * @param {boolean} [p.modal]
 */
export function Sheet({ open, onClose, title, sub, eyebrow, children, footer, width = 460, modal = false }) {
  const closeRef = React.useRef(null), box = React.useRef(null);
  if (useFocusTrap) useFocusTrap(box, !!(open && modal));
  React.useEffect(() => { if (!open) return; const k = (e) => e.key === 'Escape' && onClose && onClose(); window.addEventListener('keydown', k); const t = setTimeout(() => closeRef.current && closeRef.current.focus(), 30); return () => { window.removeEventListener('keydown', k); clearTimeout(t); }; }, [open, onClose]);
  if (!open) return null;
  return h(React.Fragment, null,
    modal ? h('div', { className: 'gx-fade', onClick: onClose, style: { position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 55 } }) : null,
    h('aside', { ref: box, role: 'dialog', 'aria-modal': modal || undefined, 'aria-label': typeof title === 'string' ? title : undefined, className: 'gx-sheet', style: { position: 'fixed', top: 0, right: 0, bottom: 0, width, maxWidth: '100vw', zIndex: 56, display: 'flex', flexDirection: 'column', background: 'var(--card)', borderLeft: ink(2), boxShadow: '-6px 0 0 var(--ink)', boxSizing: 'border-box' } },
      h('div', { style: { display: 'flex', alignItems: 'flex-start', gap: 12, padding: '18px 20px 14px', borderBottom: '2px solid var(--ink)' } },
        h('div', { style: { flex: 1, minWidth: 0 } },
          eyebrow ? h('div', { style: { marginBottom: 8 } }, eyebrow) : null,
          h('div', { style: { fontFamily: 'var(--font-title)', fontWeight: 800, fontSize: 19, letterSpacing: '-.01em', lineHeight: 1.2 } }, title),
          sub ? h('div', { style: { fontSize: 13, color: 'var(--tx2)', marginTop: 4 } }, sub) : null),
        h('button', { ref: closeRef, type: 'button', onClick: onClose, 'aria-label': 'Close panel', title: 'Close (Esc)', className: 'mo-lift', style: { display: 'grid', placeItems: 'center', width: 30, height: 30, border: ink(2), borderRadius: 8, background: 'var(--card)', boxShadow: 'var(--el-1)', color: 'var(--tx)', cursor: 'pointer', flex: 'none' } }, h(Icon, { name: 'x', size: 16 }))),
      h('div', { style: { flex: 1, overflowY: 'auto', padding: '18px 20px', display: 'flex', flexDirection: 'column', gap: 16 } }, children),
      footer ? h('div', { style: { display: 'flex', gap: 10, padding: '14px 20px', borderTop: '2px solid var(--ink)', background: 'var(--inset)' } }, footer) : null));
}
